/**
 * 开播关播相关逻辑
 * @author lianghua.fu
 * @date 2020-12-04 18:08:44
 */
import { request, user, qtClient, browser, utils } from 'lib';
import { UiToast, UiModal, Link } from 'components';
import { getUrl } from 'lib/base';
import styled from 'styled-components';
import * as room from './room';
import { getStore } from '../store';
import { getRoomId } from './room';

import joinLineLib from './join-line';
import heartbeatLib from './heartbeat-pk';
import maskPkLib from './mask-pk';

/*
var lineConfig = {
      zego: {name: '即构', alias: '推荐线路', cdnLine: 5, id: 5, pushType: 'zg'},
      agora: {name: '声网webRTC', alias: '备用线路1', cdnLine: 8, id: 11, pushType: 'agora'},
      chuangshiyun: {name: '创世云', alias: '备用线路2', cdnLine: 8, id: 8, pushType: 'flash'},
  }
 */

const lines = {
  5: {
    name: '即构',
    cdnLine: 5,
    getPullUrl(streamId) {
      return {
        rtmp_url: `rtmp://pull-aliyun.memeyule.com/memeyuleNew/${streamId}`,
        hls_url: `https://pull-aliyun.memeyule.com/memeyuleNew/${streamId}.m3u8`,
        flv_url: `https://pull-aliyun.memeyule.com/memeyuleNew/${streamId}.flv`,
      };
    },
  },
};

const isEnableTip = true;
/**
 *
 * @param data
 * {
 mic: '',
 camera: '',
 line: '5',
 visible_geo: '1',
 title: '',
 live_type: 1 // 手机 2，pc 1
 plugin:  //[1, 4x3,800x600],[2, 9x16,720x1280] 之前废弃的字段，现在用来开播类型  端x模式  如：pc 4:3,pc 16:9
 }
 */
const liveOn = ({
  title,
  line = 5,
  visible_geo = '0',
  live_type = 1,
  plugin = 1,
  auto = false,
  city,
}) => {
  if (plugin === 2) {
    live_type = 2;
  }

  request.api
    .get(`live/on/{access_token}/${room.getRoomId()}/${plugin}`, {
      v_type: lines[line].cdnLine,
      title,
      visible_geo,
      ...lines[line].getPullUrl(user.getUserId()),
      live_type,
      city,
      client_type: window.inPcClient ? 'pc_client' : 'pc_web',
      // rtmp_url,
      // hls_url,
      // flv_url
    })
    .then((res: any) => {
      // if (res.data.credit && isEnableTip) {
      //   isEnableTip = false;
      //   UiModal.confirm(
      //     '开播提示',
      //     <div className="text-left">
      //       <div style={{ textIndent: '20px' }}>
      //         请各位主播遵守
      //         <Link href="/notice/351" className="text-primary" target="_blank">
      //           《么么直播管理规定》
      //         </Link>
      //         ，直播间如出现违规内容，
      //         官方将关闭直播间，同时会扣除您的信用分值，行为严重者将进行解约。
      //       </div>
      //       <p style={{ textIndent: '2em', marginTop: '20px' }}>
      //         您当前信用分数{' '}
      //         <span className="text-primary">{res.data.credit}分</span>
      //       </p>
      //     </div>,
      //     null,
      //     null,
      //     '我知道了',
      //   );
      // }
    })
    .catch((res) => {
      getStore().room.stopLive();
      UiToast.fail(res.msg);
    });
};

const liveOff = async (reason = '', off_notify = '') => {
  await joinLineLib.liveOffExit();
  await heartbeatLib.liveOffExit();
  await maskPkLib.liveOffExit();
  return request.api
    .get(`live/off/{access_token}/${room.getRoomId()}`, {
      reason,
      off_notify,
    })
    .then(() => {
      // getStore().room.stopLive();
    })
    .catch((res) => {
      getStore().room.stopLive();
    });
};

let lastHeartBeatTime = 0;
const sendHeartBeat = () => {
  lastHeartBeatTime = Date.now();
  request
    .get(
      `live/heartbeat/{access_token}`,
      {
        room_id: room.getRoomId(),
      },
      {
        event: 'anchorClientRoom',
        event_type: 'anchorClientRoom.liveHeartbeat',
      },
    )
    .then((res) => {})
    .catch((res) => {});
};

const getLastHeartBeatTime = () => {
  return lastHeartBeatTime;
};

const showAuthPopup = () => {
  UiModal.alert({
    title: '实名认证',
    closeEnable: false,
    content: (
      <div>
        应相关部门要求，2020年11月起开播主播需完成实名与人脸认证。请尽快在
        <span style={{ fontWeight: 'bold' }}>【么么直播APP】</span>
        中点击「我」-「设置」-「账号与安全」进行认证。
      </div>
    ),
    okText: '查看认证流程',
    onOk: (e) => {
      window.open('https://www.2339.com/apply');
    },
  });
};

let limitInfo = null;
//   {
//   credit_score: 90,
//   live_limit: false,
//   live_limit_type: 2,
//   unban_timestamp: 1709953535512,
//   unban_time: '2024-03-09 11:05:35',
//   live_limit_title: '您的账号已被禁止开播',
//   live_limit_desc: '经检测，您的账号存在以下违规行为，已被禁止开播',
//   live_limit_logs: [
//     '禁止开播111111',
//     '经检测，您的账号存在以下违规行为，已被禁止开播，违规行为，已被禁止开播',
//   ],
//   join_line_limit: false,
//   join_line_limit_count: 0,
//
//   join_line_limit_title: '禁止pk连麦',
//   join_line_limit_desc: '禁止pk连麦禁止pk连麦禁止pk连麦禁止pk连麦',
//
//   fun_limit: false,
//   chat_limit: false,
//   headline_limit: false,
//   home_limit: false,
// };
const getLimitInfo = (forceLoad = false) => {
  // https://mock.memeyule.com/project/16/interface/api/22988
  // if (limitInfo && !forceLoad) {
  //   return limitInfo;
  // }
  return request.cryolite.get(`/api/v1/star/credit/limit`).then((res: any) => {
    limitInfo = res.data;
    return res.data;
  });
};

// https://mock.memeyule.com/project/16/interface/api/23146
// return "0":不需要考试 "1":主播首次开播考试 "2":每月首次开播考试
const getExamStatus = () => {
  return request.cryolite.get('/api/v2/star/answer-status').then((res: any) => {
    return res.data;
  });
};

const CheckPopup = styled.div`
  //text-align: center;
  .desc {
    padding: 10px 0;
    text-align: left;
  }
  .rule {
    color: #333333;
    padding: 10px 0;
  }
  .time {
    color: #999999;
  }
`;

// 开播检测
const liveCheck = async () => {
  try {
    const examStatus = await getExamStatus();
    if (examStatus === 1) {
      UiModal.alert({
        title: '主播首播问答',
        content: (
          <div>
            <p>
              欢迎入驻么么直播平台，这是您的首次开播，为了帮助您快速了解平台相关政策条款，请先完成“主播首播问答”
            </p>
            <p className="text-primary">正确率 100% 视为通过，没过可重考</p>
          </div>
        ),
        okText: '开始答题',
        onOk: () => {
          UiModal.iframe({
            url: getUrl(`/app/star/live-exam/examination?status=${examStatus}`, 'h5'),
            isH5Popup: true,
            title: '主播首播问答',
          });
        },
        // cancelText: '确定',
      });
      return false;
    }
    if (examStatus === 2) {
      UiModal.alert({
        title: '主播知识问答',
        content: (
          <div>
            <p>为了帮助您时刻掌握平台相关最新政策条款，每月首次开播前请先完成“主播知识问答”</p>
            <p className="text-primary">正确率 100% 视为通过，没过可重考</p>
          </div>
        ),
        okText: '开始答题',
        onOk: () => {
          UiModal.iframe({
            url: getUrl(`/app/star/live-exam/examination?status=${examStatus}`, 'h5'),
            isH5Popup: true,
            title: '主播知识问答',
          });
        },
        // cancelText: '确定',
      });
      return false;
    }

    const limitInfo = await getLimitInfo();

    if (limitInfo.live_limit) {
      // 0-被禁播 1-信用分禁播 2-信用分低需要考试才能直播
      if (limitInfo.live_limit_type === 0) {
        UiModal.alert({
          title: limitInfo.live_limit_title,
          content: (
            <CheckPopup>
              <p>{limitInfo.live_limit_desc} </p>
              <ul className="desc">
                {limitInfo.live_limit_logs.map((item, index) => {
                  return (
                    <li key={index}>
                      {index + 1}.{item}
                    </li>
                  );
                })}
              </ul>

              <div className="rule">
                <Link href="/notice/10497" className="text-primary" target="_blank">
                  《主播管理协议》
                </Link>
              </div>
              <div className="time">禁播结束时间至：{limitInfo.unban_time}</div>
            </CheckPopup>
          ),
          okText: '我要申诉',
          onOk: () => {
            UiModal.iframe({
              url: getUrl(`/app/star/credit-record`, 'h5'),
              isH5Popup: true,
              title: '信用分流水',
            });
          },
          cancelText: '确定',
        });
      }
      if (limitInfo.live_limit_type === 1) {
        UiModal.alert({
          title: limitInfo.live_limit_title,
          content: (
            <div>
              <p>{limitInfo.live_limit_desc} </p>
            </div>
          ),
          okText: '提升信用分',
          onOk: () => {
            UiModal.iframe({
              url: getUrl(`/app/star/credit`, 'h5'),
              isH5Popup: true,
              title: '我的信用',
            });
          },
          cancelText: '确定',
        });
      }
      if (limitInfo.live_limit_type === 2) {
        UiModal.alert({
          title: limitInfo.live_limit_title,
          content: (
            <div>
              <p>{limitInfo.live_limit_desc} </p>
            </div>
          ),
          okText: '去考试',
          onOk: () => {
            UiModal.iframe({
              url: getUrl(`/app/star/exam/prepare`, 'h5'),
              isH5Popup: true,
              title: '主播考核',
            });
          },
          cancelText: '确定',
        });
      }

      return false;
    }
  } catch (err) {
    UiToast.fail(err?.msg || '开播检测异常');
    return false;
  }

  return true;
};

// 发起连麦检测
const joinLiveCheck = async () => {
  try {
    const limitInfo = await getLimitInfo();

    if (limitInfo.join_line_limit) {
      UiModal.alert({
        title: limitInfo.join_line_limit_title,
        content: (
          <div>
            <p>{limitInfo.join_line_limit_desc} </p>
          </div>
        ),
        okText: '提升信用分',
        onOk: () => {
          UiModal.iframe({
            url: getUrl(`/app/star/credit`, 'h5'),
            isH5Popup: true,
            title: '我的信用',
          });
        },
        cancelText: '确定',
      });
      return false;
    }
  } catch (e) {
    UiToast.fail('连麦检测异常');
    return false;
  }

  return true;
};

export default {
  getLimitInfo,
  liveCheck,
  joinLiveCheck,
  liveOn,
  liveOff,
  sendHeartBeat,
  getLastHeartBeatTime,
  showAuthPopup,
};
